import { useEffect, useState } from "react";
import { api } from "../lib/api";

let cache = null;

export function useCupping() {
  const [data, setData] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    api.get("/cupping").then((r) => { cache = r.data; setData(r.data); }).catch(() => {});
  }, []);
  return data;
}

export const invalidateCupping = () => { cache = null; };
